import Active from '../../img/active.png';
import Inactive from '../../img/inactive.png';

export const setCoverStatus = (name, condition) => {
    return condition ?  <h2 style={{whiteSpace: 'nowrap', margin: 'auto',  width: 'fit-content'}}> {name}  <span><img style={{width: '24px'}} src={Active} alt="active" /></span></h2>
    : <h2 style={{color: '#5f6a6a', whiteSpace: 'nowrap', margin: 'auto', width: 'fit-content'}}> {name} <span><img style={{width: '24px'}} src={Inactive} alt="inactive" /></span></h2>
}

